
import { Nullable } from '@/types-helpers';
import { Component } from 'vue-property-decorator';
import AppConstants from '../model/AppConstants';
import Template from '../model/templating/Template';
import Base from './Base.vue';

@Component({
  props: ['appTemplate'],
})
export default class App extends Base {
  showGitlabIssuer = false;

  appTemplate!: Nullable<Template>;

  mounted() {
    window.addEventListener('click', this.showGitlabIssuerSwitch);
  }

  beforeDestroy() {
    window.removeEventListener('click', this.showGitlabIssuerSwitch);
  }

  get template(): Template {
    return this.appTemplate ?? this.$store.getters.template ?? {};
  }

  showGitlabIssuerSwitch() {
    this.showGitlabIssuer = !this.showGitlabIssuer;
  }

  /**
   * Status en ligne (connexion temps-réel au serveur)
   */
  get online(): boolean {
    return this.$store.getters.online;
  }

  get appStyle() {
    return {
      'background-color': 'black',
      'font-family': this.theme.font1,
    };
  }

  /**
   * Retourne la bonne classe de rotation CSS par rapport à la configuration de l'écran
   * Elle est appliquée au wrapper. (voir style)
   */
  get rotation(): string {
    let rotation = this.dataset(AppConstants.APP_DATASET_NAME)?.rotate?.toString() || 'none';
    if (window.location.href.includes('norotate')) rotation = 'none';
    return rotation;
  }

  get env() {
    return process.env.NODE_ENV;
  }
}
